import { render, staticRenderFns } from "./aks-agfc.vue?vue&type=template&id=fb20412a&scoped=true&"
import script from "./aks-agfc.vue?vue&type=script&lang=js&"
export * from "./aks-agfc.vue?vue&type=script&lang=js&"
import style0 from "./aks-agfc.vue?vue&type=style&index=0&id=fb20412a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb20412a",
  null
  
)

export default component.exports